import React from 'react';
import { EventsFiltersState } from '../../hooks/useEventsFilters';
import '../common/Common.css';

interface Props {
  filters: EventsFiltersState;
  onChange: <K extends keyof EventsFiltersState>(key: K, value: EventsFiltersState[K]) => void;
  onReset: () => void;
  showApartmentName?: boolean;
}

const EventsFilterBar: React.FC<Props> = ({ filters, onChange, onReset, showApartmentName = true }) => (
  <div className="filter-bar">
    <input
      type="date"
      className="filter-bar__date"
      value={filters.startDate}
      onChange={e => onChange('startDate', e.target.value)}
      aria-label="시작 날짜"
    />
    <input
      type="time"
      className="filter-bar__time"
      value={filters.startTime}
      onChange={e => onChange('startTime', e.target.value)}
      aria-label="시작 시각"
    />
    <span className="filter-bar__sep">~</span>
    <input
      type="date"
      className="filter-bar__date"
      value={filters.endDate}
      onChange={e => onChange('endDate', e.target.value)}
      aria-label="종료 날짜"
    />
    <input
      type="time"
      className="filter-bar__time"
      value={filters.endTime}
      onChange={e => onChange('endTime', e.target.value)}
      aria-label="종료 시각"
    />
    {showApartmentName && (
      <input
        type="text"
        className="filter-bar__input"
        placeholder="장소명 검색"
        value={filters.apartmentName}
        onChange={e => onChange('apartmentName', e.target.value)}
      />
    )}
    <input
      type="text"
      className="filter-bar__input"
      placeholder="차량번호 검색"
      value={filters.carNumber}
      onChange={e => onChange('carNumber', e.target.value)}
    />
    <button className="btn btn--secondary btn--sm" onClick={onReset}>초기화</button>
  </div>
);

export default EventsFilterBar;
